export default __webpack_public_path__ + "images/Dia-Bold.font.bed5a84f6d1391c37f4713635bb25d25.svg";